import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SearchContainer = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e5e5ea;
  background-color: #fafafa;
`;

export const ListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  padding: 12px 24px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 4px;
  }
`;

export const ListItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9f9f9;
    border-color: #e5e5ea;
  }
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemLabel = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const ItemCode = styled.span`
  font-size: 12px;
  color: #8e8e93;
  margin-top: 4px;
`;

export const StepContainer = styled.div`
  padding: 20px 24px;
`;

export const SelectedBorderInfo = styled.div`
  background-color: #f0f9ff;
  border: 1px solid #bae0ff;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  color: #0050b3;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
`;

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 6px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
    border-radius: 4px;
  }
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  background-color: #ffffff;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  &:hover {
    border-color: #d0d0d5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  }

  .label-col {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .inputs-wrapper {
    display: flex;
    gap: 16px;
  }

  .input-col {
    width: 150px;

    label {
      display: block;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 6px;
      color: #8e8e93;
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;

    .label-col {
      width: 100%;
      border-bottom: 1px solid #f2f2f7;
      padding-bottom: 12px;
      margin-bottom: 12px;
    }

    .inputs-wrapper {
      width: 100%;
      justify-content: space-between;
    }

    .input-col {
      flex: 1;
      width: auto;
    }
  }
`;

export const LoadingText = styled.div`
  text-align: center;
  padding: 40px;
  color: #8e8e93;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #8e8e93;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px dashed #e5e5ea;
`;

export const ModalFooter = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #fcfcfc;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
`;
